import { Request } from '../classes/Request';
import { RequestNewVersion } from '../classes/RequestNewVersion';
import { NotificationManager } from 'react-notifications';
import Cookies from 'js-cookie';
////////////////////////////////////////////////////FUNCTION THAT FETCHES THE USER MANUAL/////////////////////////////////////////////////////////////////

export const getUserManualByGroupsId = async (
  setFirstText,
  setSecondText,
  setHowManyManuals,
  setDataButtons
) => {
  const { userId_03 } = Cookies.get();
  const request = new Request(
    `${process.env.REACT_APP_URL_API_LARAVEL}/groups/manuals/${userId_03}`,
    'get',
    null,
    {}
  );
  const responseManuals = await request.executeRequest();

  if (responseManuals.code === 200) {
    if (
      responseManuals.data.data.data.manuals &&
      responseManuals.data.data.data.manuals.length > 1
    ) {
      setFirstText('los manuales de usuario que describen');
      setSecondText('visualizarlos haz clic en los siguientes enlaces');
      setHowManyManuals('Manuales');
      setDataButtons(responseManuals.data.data.data.manuals);
    } else if (
      responseManuals.data.data.data.manuals &&
      responseManuals.data.data.data.manuals.length < 2
    ) {
      setDataButtons(responseManuals.data.data.data.manuals);
    }
  }
};

// The manual route requires the shared token, so core issues a one-time link that keeps it server-side.
export const downloadManual = async (group) => {
  const request = new RequestNewVersion(
    `${process.env.REACT_APP_URL_API_LARAVEL}/download/sign`,
    'post',
    null,
    { file_id: group.id, type: 'manual' }
  );
  const result = await request.executeRequest();
  const signedUrl =
    result && result.completeResponse && result.completeResponse.data
      ? result.completeResponse.data.url
      : null;

  if (!signedUrl) {
    NotificationManager.error('No se pudo generar el enlace de descarga del manual');
    return;
  }

  window.open(signedUrl, '_blank', 'noopener,noreferrer');
};

export const xmlHttpRequestManualDownload = (url, success) => {
  const { authentication_token_03 } = Cookies.get();
  let xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.setRequestHeader(
    'Authorization',
    Buffer.from(process.env.REACT_APP_TOKEN).toString('base64')
  );
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  xhr.responseType = 'blob';
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 401) {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.setRequestHeader('Authorization', authentication_token_03);
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.responseType = 'blob';
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (success) {
              success(xhr.response);
            }
          }
        };
        xhr.send();
      } else {
        if (success) {
          success(xhr.response);
        }
      }
    }
  };
  xhr.send();
};
